import { render, staticRenderFns } from "./updateGroupDialog.vue?vue&type=template&id=23d52719"
import script from "./updateGroupDialog.vue?vue&type=script&lang=js"
export * from "./updateGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports